"use client";
import { JobAndToast } from '@/types/types';

const debug = process.env.DEBUG === 'true';
interface HeroHeadingProps {
    jobAndToast: JobAndToast;
}


const EmptyPageComponent: React.FC<HeroHeadingProps> = ({
    jobAndToast
}) => {

    return (
        <section className={`container mx-auto py-10 ${debug ? 'bg-red-500' : ''}`}>
            <b>Job {jobAndToast.job?.Name} </b> Not ready yet. Come back later!
        </section>
    );
};

export default EmptyPageComponent;